import React from 'react';
import { motion } from 'framer-motion';
export function CostTable() {
  const data = [{
    sin: 'Años buscando diagnóstico correcto',
    costo: '5 a 7 años en promedio en Argentina'
  }, {
    sin: 'Probióticos, antibióticos y dietas que no funcionan',
    costo: 'Dinero y energía en soluciones parciales'
  }, {
    sin: 'Vida social limitada por miedo a inflamarte',
    costo: 'Asados y salidas que generan ansiedad'
  }, {
    sin: 'Fatiga crónica y niebla mental',
    costo: 'Productividad y calidad de vida reducidas'
  }, {
    sin: 'Google con información contradictoria',
    costo: 'Más confusión, menos resultados'
  }, {
    sin: 'Consultas médicas que no llegan al fondo del problema',
    costo: 'Miles de pesos en turnos sin respuestas claras'
  }, {
    sin: 'Estrés constante por no saber qué comer',
    costo: 'Ansiedad diaria frente a cada comida'
  }, {
    sin: 'Sueño interrumpido por molestias digestivas',
    costo: 'Noches sin descanso que afectan todo tu día'
  }, {
    sin: 'Depender de medicamentos sin plan de salida',
    costo: 'Dependencia sin mejoría real a largo plazo'
  }, {
    sin: 'Otro año con el mismo globo',
    costo: 'El mismo ciclo. La misma frustración. El año que viene.'
  }];
  return <section className="py-24 bg-brand-dark" data-id="element-71">
      <div className="container mx-auto px-4" data-id="element-72">
        <div className="max-w-4xl mx-auto" data-id="element-73">
          <div className="text-center mb-12" data-id="element-74">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-gold font-[Poppins,_sans-serif]" data-id="element-75">
              ⚖️ ¿CUÁNTO CUESTA NO TENER EL PROTOCOLO?
            </h2>
          </div>

          <div className="bg-[#0a2a1a] rounded-2xl border border-[#1a4a2e] overflow-hidden mb-16" data-id="element-76">
            {data.map((row, i) => <div key={i} data-id="element-77">
                <div className="border-l-4 border-[#2d6b45] px-5 py-4 bg-[#0d2f1e]" data-id="element-78">
                  <p className="text-sm md:text-base font-[700] text-[#FFFFFF]" data-id="element-79">
                    ❌ {row.sin}
                  </p>
                </div>
              </div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-80">
            <p className="text-2xl font-bold text-white mb-6" data-id="element-81">
              El próximo lunes puede ser diferente.
            </p>
            <p className="text-xl md:text-3xl font-bold text-brand-light italic font-[Poppins,_sans-serif]" data-id="element-82">
              "Tu intestino no está roto. Solo está esperando el mapa correcto."
              🌿
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}